import CryptoJS from "crypto-js";
import { getBaseUrl, getpwUrl } from "./commonUtil";
import { logOut } from '../Auth0/SessionProvider';

let navHomeURL;
if (getpwUrl) {
  navHomeURL = getpwUrl();
}

export const setsessionData = () => {
  var abc = {
    "username": "robin19",
    "challengeLockCount": 0,
    "coachMarks": [
      {
        "seqCoachMarkId": 2002,
        "seqPartyId": 604646,
        "visistedScreen": "Account Summary",
        "visitedOn": 1561443242041
      }
    ],
    "partyId": 604646,
    "partyFreezes": [],
    "csrBusinessFunctions": null,
    "csrUser": null,
    "originalOpenDate": null,
    "accountName": null,
    "accountNumber": null,
    "accountClass": null,
    "accountIdentifier": null,
    "accountStatus": null,
    "currentBalance": null,
    "availableBalance": null,
    "feeTemplate": null,
    "establishedDate": null,
    "segmentation": null,
    "bookOfBusiness": null,
    "accountRole": null,
    "accountRepresentative": null,
    "professionalAdvisorTitle": null,
    "vangaurdClient": null,
    "primaryAccountContact": false,
    "grantAgreementFlag": false,
    "accessKeyGeneratedAndActive": false,
    "accessKeyLinked": false,
    "accountAllRoles": null,
    "financialAdvisorForAnyAccount": false,
    "PrimaryAccountForParty": "88760",
    "Accounts": [
      {
        "role": {
          "readOnlyWithExchange": "false",
          "access": "All Access"
        },
        "accountName": "The hjkdfeyetrioiio Fund",
        "currentBalance": 0,
        "accountType": "Standard",
        "freezes": [],
        "RyHCQ2A9LUqw1GDO1cYD3w==": "96925"
      },
      {
        "role": {
          "readOnlyWithExchange": "false",
          "access": "All Access"
        },
        "accountName": "The dsfgdgfd Fund",
        "currentBalance": 0,
        "accountType": "Standard",
        "freezes": [],
        "rKVqqOTlOg4ckdz16kpgBw==": "96924"
      },
      {
        "role": {
          "readOnlyWithExchange": "false",
          "access": "All Access"
        },
        "accountName": "The hasgasdf Fund",
        "currentBalance": 0,
        "accountType": "Standard",
        "freezes": [],
        "3Rgf/W4uVU46CB/cboNBeg==": "96922"
      },
      {
        "role": {
          "readOnlyWithExchange": "false",
          "access": "All Access"
        },
        "accountName": "The Testing Fund",
        "currentBalance": 0,
        "accountType": "Standard",
        "freezes": [],
        "DHcOC8yBFQXgw1ftaLFv+A==": "91666"
      },
      {
        "role": {
          "readOnlyWithExchange": "false",
          "access": "All Access"
        },
        "accountName": "The jdsfgdfg Fund",
        "currentBalance": 0,
        "accountType": "Standard",
        "freezes": [],
        "lgR/GCaH7KCBjoFe2oYSdQ==": "96921"
      },
      {
        "role": {
          "readOnlyWithExchange": "false",
          "access": "All Access"
        },
        "accountName": "The hasdfsdf Fund",
        "currentBalance": 0,
        "accountType": "Standard",
        "freezes": [],
        "nnUKrESAerHZY9aMbGqDBQ==": "96923"
      },
      {
        "role": {
          "readOnlyWithExchange": "false",
          "access": "All Access"
        },
        "accountName": "The Indian Fund",
        "currentBalance": 724806608.48,
        "accountType": "Standard",
        "freezes": [],
        "BQdv73huTTrtdSFVJXi/EA==": "88760"
      }
    ]
  };  
  sessionStorage.setItem("userData", JSON.stringify(abc));
};

export const setGeminiSessionData = () => {
  var token = {
    access_token: "9e72a446-4d1d-4657-a9cf-5cf590e9fdba",
    expires_in: 5950,
    refresh_token: "ae261a68-4b07-4688-84c2-f8779a453261",
    scope: "read",
    token_type: "bearer"
  };
  
  sessionStorage.setItem(
    "tokenInfo",
    JSON.stringify(token)
  );  
};

export const setGeminiUser = (value) => {  
  let geminiUser = sessionStorage.getItem('geminiUser') === 'Yes';
  if(geminiUser) return sessionStorage.setItem('geminiUser', true)
}

export const isGeminiUser = () => {  
  return process.env.REACT_APP_GEMINI_USER === 'true';  
}

export const setToSessionStorage = async (key, value) =>
  sessionStorage.setItem(key, value);
  
export const getFromSessionStorage = key => sessionStorage.getItem(key);

export const getPrimaryAccount = () => {
  getTokenInfo();  
  const primaryAccount = JSON.parse(sessionStorage.getItem("primaryAccount"));
  if (primaryAccount) {

    return primaryAccount;
  } else {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    if(!userData) return false;
    return userData.PrimaryAccountForParty;
  }
};

export const getAccountData = () => {
  return JSON.parse(sessionStorage.getItem("userData"));
};

export const getTokenInfo = () => {
  if (isGeminiUser()) {
    if(!JSON.parse(sessionStorage.getItem("tokenInfo"))) {
      localStorage.clear();
      sessionStorage.clear();
      sessionStorage.setItem("hasLoggedOut", true);
      sessionStorage.setItem("LastPageUrl", window.location.href);
      sessionStorage.setItem("fromPage", "refreshToken");
      window.location.href = getpwUrl();
    } else {
      return JSON.parse(sessionStorage.getItem("tokenInfo"));
    }
  }
};

export const setPrimaryAccount = account => {
  sessionStorage.setItem("primaryAccount", JSON.stringify(account));
};

export const checkPrimaryAcc = () => {
  return JSON.parse(sessionStorage.getItem("primaryAccount"));
};
export const decryptAccountNumber = _encrypted => {
  if (_encrypted != null) {
    const _key = CryptoJS.enc.Base64.parse("253D3FB468A0E24677C28A624BE0F939");
    const _iv = CryptoJS.enc.Base64.parse("5D9r9ZVzEYYgha93/aUK2w==");

    const decrypted = CryptoJS.AES.decrypt(_encrypted, _key, { iv: _iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
};

export const encryptAccountNumber = _accNum => {
  if (_accNum != null) {
    const _key = CryptoJS.enc.Base64.parse("253D3FB468A0E24677C28A624BE0F939");
    const _iv = CryptoJS.enc.Base64.parse("5D9r9ZVzEYYgha93/aUK2w==");
    const _encrypted = CryptoJS.AES.encrypt(_accNum, _key, { iv: _iv });
    return _encrypted.toString();
  }
};

export const updateSession = data => {
  let userData = JSON.parse(sessionStorage.getItem("userData"));
  if (userData) {
    userData.coachMarks.push(data);
  }
  sessionStorage.setItem("userData", JSON.stringify(userData));
};

export const updateFundName = data => {
  let userData = JSON.parse(sessionStorage.getItem("userData"));
  let primaryAccount = JSON.parse(sessionStorage.getItem("primaryAccount"));

  userData.Accounts.map((item, i) => {
    for (let key in item) {
      if (
        key !== "role" &&
        key !== "accountName" &&
        key !== "currentBalance" &&
        key !== "accountType" &&
        key !== "freezes"
      ) {
        if (item[key] === primaryAccount.userId) {
          item.accountName = data;
        }
      }
    }
  });
  primaryAccount.accountName = data;
  sessionStorage.setItem("userData", JSON.stringify(userData));
  sessionStorage.setItem("primaryAccount", JSON.stringify(primaryAccount));
};

/**Function to set user's accounts list in session storage by encrypting account ids
 * @param {Object} userInfo - user information of logged in user
 */
export const setUserAccounts = (userInfo={}) => {
  if(userInfo) {  
    const userData = getAccountData();
    if(!userData || isGeminiUser()) {      
      let accounts = userInfo.Accounts;
      userInfo.Accounts = accounts.map(i => {
        let keys = Object.keys(i);          
        let key = keys.find(k => k !== 'role' && k !== 'accountName' && k !== 'currentBalance' && k !== 'accountType' && k !== 'freezes');          
        let encryptKey = encryptAccountNumber(key);
        i[encryptKey] = i[key];
        delete i[key];          
        return i;
      })
      if(userInfo.csrUser) {
        let primaryAccount;
        userInfo.Accounts.forEach(function(acc) {
          if(Object.values(acc).some((val)=>val == userInfo.PrimaryAccountForParty) ) {
            primaryAccount = acc;
            primaryAccount.userId = userInfo.PrimaryAccountForParty;
            primaryAccount.accountNumber = userInfo.accountNumber;
            setToSessionStorage('primaryAccount', JSON.stringify(primaryAccount));
          }
          delete acc["accountNumber"];
          delete acc["userId"];
        });
      }
      sessionStorage.setItem("userData", JSON.stringify(userInfo));
      sessionStorage.removeItem("hasLoggedOut");
      sessionStorage.removeItem("fromPage");
    }
  }
  return;
}

export const sessionFlush = frompage => {
  if(isGeminiUser()) {
    var xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function() {
      if (xmlhttp.readyState == XMLHttpRequest.DONE) {
        localStorage.clear();
        sessionStorage.clear();
        sessionStorage.setItem("hasLoggedOut", true);
        sessionStorage.setItem("fromPage", frompage);
        window.location.href = navHomeURL;
      }
    };
    xmlhttp.open(
      "POST",
      `${getBaseUrl()}/donor-portal/api/party/${
        getAccountData().partyId
      }/revokeAccessToken`,
      true
    );
    xmlhttp.setRequestHeader("content-type", "application/json");
    xmlhttp.setRequestHeader(
      "Authorization",
      "Bearer " + JSON.parse(sessionStorage.getItem("tokenInfo")).access_token
    );
    xmlhttp.send();
  } else {
    logOut(frompage);
  }
};

var tokenFailureCount = 0;
export const refreshToken = (cb, min) => {
  function initiateTokenRequest(tokenValidity) {
    var fetchAfter =
      tokenValidity - 120000 > 120000 ? tokenValidity - 120000 : 0;
    setTimeout(function() {
      fetchNewToken();
    }, fetchAfter);
  }

  function fetchNewToken() {
    var Base64 = {
      _keyStr:
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      encode: function(e) {
        var t = "";
        var n, r, i, s, o, u, a;
        var f = 0;
        e = Base64._utf8_encode(e);
        while (f < e.length) {
          n = e.charCodeAt(f++);
          r = e.charCodeAt(f++);
          i = e.charCodeAt(f++);
          s = n >> 2;
          o = ((n & 3) << 4) | (r >> 4);
          u = ((r & 15) << 2) | (i >> 6);
          a = i & 63;
          if (isNaN(r)) {
            u = a = 64;
          } else if (isNaN(i)) {
            a = 64;
          }
          t =
            t +
            this._keyStr.charAt(s) +
            this._keyStr.charAt(o) +
            this._keyStr.charAt(u) +
            this._keyStr.charAt(a);
        }
        return t;
      },
      decode: function(e) {
        var t = "";
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (f < e.length) {
          s = this._keyStr.indexOf(e.charAt(f++));
          o = this._keyStr.indexOf(e.charAt(f++));
          u = this._keyStr.indexOf(e.charAt(f++));
          a = this._keyStr.indexOf(e.charAt(f++));
          n = (s << 2) | (o >> 4);
          r = ((o & 15) << 4) | (u >> 2);
          i = ((u & 3) << 6) | a;
          t = t + String.fromCharCode(n);
          if (u != 64) {
            t = t + String.fromCharCode(r);
          }
          if (a != 64) {
            t = t + String.fromCharCode(i);
          }
        }
        t = Base64._utf8_decode(t);
        return t;
      },
      _utf8_encode: function(e) {
        e = e.replace(/\r\n/g, "\n");
        var t = "";
        for (var n = 0; n < e.length; n++) {
          var r = e.charCodeAt(n);
          if (r < 128) {
            t += String.fromCharCode(r);
          } else if (r > 127 && r < 2048) {
            t += String.fromCharCode((r >> 6) | 192);
            t += String.fromCharCode((r & 63) | 128);
          } else {
            t += String.fromCharCode((r >> 12) | 224);
            t += String.fromCharCode(((r >> 6) & 63) | 128);
            t += String.fromCharCode((r & 63) | 128);
          }
        }
        return t;
      },
      _utf8_decode: function(e) {
        var t = "";
        var n = 0;
        var c1, c2;
        var r = (c1 = c2 = 0);
        while (n < e.length) {
          r = e.charCodeAt(n);
          if (r < 128) {
            t += String.fromCharCode(r);
            n++;
          } else if (r > 191 && r < 224) {
            c2 = e.charCodeAt(n + 1);
            t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
            n += 2;
          } else {
            c2 = e.charCodeAt(n + 1);
            var c3;
            c3 = e.charCodeAt(n + 2);
            t += String.fromCharCode(
              ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
            );
            n += 3;
          }
        }
        return t;
      }
    };

    var authbase64string = "Basic " + Base64.encode("donorPortalUI:secret");

    (function() {
      var xmlhttp = new XMLHttpRequest();

      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) {
          if (xmlhttp.status == 200) {
            if (xmlhttp.responseText && xmlhttp.responseText.error) {
              ++tokenFailureCount;
              if (tokenFailureCount === 1) {
                initiateTokenRequest(1);
              } else {
                sessionFlush("refreshToken");
              }
              return;
            }
            if (typeof xmlhttp.responseText === "string") {
              var thisResponse = JSON.parse(xmlhttp.responseText);
              if (thisResponse && thisResponse.error) {
                ++tokenFailureCount;
                if (tokenFailureCount === 1) {
                  initiateTokenRequest(1);
                } else {
                  sessionFlush("refreshToken");
                }
                return;
              }
            }
            sessionStorage.setItem("tokenInfo", xmlhttp.responseText);
            if (window.top.frames.topBar !== undefined) {
              window.top.frames.topBar.postMessage(
                {
                  message: "refreshToken",
                  tokenInfo: JSON.parse(sessionStorage.getItem("tokenInfo")),
                  refreshToken: JSON.parse(sessionStorage.getItem("tokenInfo"))
                    .refresh_token
                },
                process.env.REACT_APP_GEMINI_CSR_URL
              );
            }
            initiateTokenRequest(480000);
            cb(null, true);
          } else if (xmlhttp.status == 400) {
            sessionFlush("refreshToken");
            cb(true, null);
          } else if (xmlhttp.status >= 500) {
            ++tokenFailureCount;
            if (tokenFailureCount === 1) {
              initiateTokenRequest(1);
            } else {
              sessionFlush("refreshToken");
            }

            cb(true, null);
          } else {
            sessionFlush("refreshToken");
            cb(true, null);
          }
        }
      };

      xmlhttp.open(
        "POST",
        `${getBaseUrl()}/donor-portal/api/oauth/token`,
        true
      );
      xmlhttp.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      xmlhttp.setRequestHeader("when", new Date());
      xmlhttp.setRequestHeader("Authorization", authbase64string);
      xmlhttp.send(
        "grant_type=refresh_token&refresh_token=" +
          JSON.parse(sessionStorage.getItem("tokenInfo")).refresh_token
      );
    })();
    return;
  }
  initiateTokenRequest(min);
};